import { createRouteRef } from '@backstage/core-plugin-api';

export const storybookRouteRef = createRouteRef({
  id: 'storybook',
});

export const systemStatusRouteRef = createRouteRef({
  id: 'system-status',
});

export const grafanaRouteRef = createRouteRef({
  id: 'grafana',
});
